'use strict';

(function initializeNpcWorkshopRecentAdapter(root) {
    const app = root.dndNextLevel;
    const state = app.npcWorkshopState;
    const TYPE = 'npc-workshop';
    const RESTORE_KEY = 'dnd-next-level:npc-workshop:restore:v1';
    const MIGRATION_KEY = 'dnd-next-level:npc-workshop:recent-migrated:v1';
    const documentFrom = source => {
        if (state.isCanonical(source?.document)) return source.document;
        if (state.isCanonical(source)) return source;
        const raw = source?.querySelector?.('[data-persisted-fragment-document]')?.dataset?.persistedFragmentDocument;
        const parsed = state.parseObject(raw);
        return state.isCanonical(parsed) ? parsed : null;
    };
    const capture = source => {
        const document = documentFrom(source);
        return document ? {version: 2, document: JSON.parse(JSON.stringify(document))} : null;
    };
    const validate = payload => payload?.version === 2 && state.isCanonical(payload.document);
    const adapter = {
        type: TYPE,
        route: '/npc-workshop',
        capture,
        validate,
        preview(payload) {
            if (!validate(payload)) throw new Error('Invalid NPC Workshop recent creation');
            const npc = payload.document.workshop.npc;
            return {title: state.displayName(npc) || 'Unnamed NPC',
                description: [npc.specieLabel || npc.specie, npc.occupation || npc.characterClass].filter(Boolean).join(' · ')};
        },
        restore(payload) {
            if (!validate(payload)) throw new Error('Invalid NPC Workshop recent creation');
            root.localStorage.setItem(state.currentKey(), JSON.stringify(payload.document));
            root.location.assign(adapter.route);
            return payload.document;
        },
    };
    const sharedStore = storage => app.recentCreationStore.create(storage);
    const readShared = storage => sharedStore(storage).read().filter(entry => entry.type === TYPE);
    const saveCurrent = (source, storage, pinned = false, now = Date.now()) => {
        const payload = capture(source);
        if (!validate(payload)) return null;
        const store = sharedStore(storage);
        const previous = store.read().find(entry => entry.type === TYPE && entry.id === 'current');
        const entry = {id: 'current', type: TYPE, createdAt: previous?.createdAt ?? now, updatedAt: now,
            pinned: pinned || previous?.pinned === true, payload};
        store.save(entry);
        app.recentCreations?.instance?.render();
        return entry;
    };
    const migrateLegacy = (storage, now = Date.now()) => {
        if (storage.getItem(MIGRATION_KEY) === 'complete') return 0;
        const current = state.migrateCurrent(storage);
        const currentNpc = JSON.stringify(current?.workshop?.npc);
        let migrated = 0;
        state.readHistory(storage).forEach((workshop, index) => {
            if (!workshop?.npc || JSON.stringify(workshop.npc) === currentNpc) return;
            const payload = capture(state.canonicalFromWorkshop(workshop));
            sharedStore(storage).save({id: `legacy-${index}`, type: TYPE, createdAt: now - index,
                updatedAt: now - index, pinned: false, payload});
            migrated++;
        });
        storage.setItem(MIGRATION_KEY, 'complete');
        return migrated;
    };
    const consumeRestore = (storage, sessionStorage) => {
        const raw = sessionStorage.getItem(RESTORE_KEY);
        sessionStorage.removeItem(RESTORE_KEY);
        const legacy = state.parseObject(raw);
        if (!legacy) return null;
        const document = validate(legacy) ? legacy.document : legacy.saved
            ? state.canonicalFromWorkshop(legacy.saved,
                legacy.access?.locked ? {exportDmSecrets: false, editable: false} : {exportDmSecrets: true, editable: true},
                legacy.locks || {version: 1, fields: []}) : null;
        if (document) storage.setItem(state.currentKey(), JSON.stringify(document));
        return document;
    };
    app.npcWorkshopRecentAdapter = {adapter, saveCurrent, migrateLegacy, consumeRestore, readShared, RESTORE_KEY, MIGRATION_KEY};
    app.recentCreationAdapters?.registry?.register(adapter);
})(window);
